import { render, staticRenderFns } from "./file-version.vue?vue&type=template&id=8c5cff6a&scoped=true&"
import script from "./file-version.ts?vue&type=script&lang=ts&"
export * from "./file-version.ts?vue&type=script&lang=ts&"
import style0 from "./file-version.scss?vue&type=style&index=0&id=8c5cff6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5cff6a",
  null
  
)

export default component.exports